<h3 mat-dialog-title>Разблокировка пользователя</h3>
<div mat-dialog-content>
  <p>Вы действительно хотите разблокировать пользователя?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="primary"
          cdkFocusInitial
          (click)="onSubmit()">Разблокировать
  </button>
</div>
